import { baseApi } from "./baseApi";
import { OrderResponseView } from "../models/api/order/orderResponseView";

export const ordersApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        ordersByUserId: builder.query<OrderResponseView[], void>({
            query: () => `${import.meta.env.VITE_ORDERS_CRUD}`,
            providesTags: ["orders"],
        }),
    }),
});

export const { useOrdersByUserIdQuery } = ordersApi;
